export default {
	name: 'Convention.Registration.Purchases',
	collection: true,
	topLevel: true,
	form: {
		component: 'ConventionRegistrationPurchase',
		api: 'convention/registration/purchase',
		noun: 'purchase'
	}
}